module.exports = __webpack_public_path__ + "img/auto_grid.f8163240.svg";